import moment from 'moment';
import Logger from 'utilities/logger';

const VAULT = {};

const getVault = () => {
  const prepare = key => (Array.isArray(key) ? key.join(',') : key);
  return {
    get(key) {
      const item = VAULT[prepare(key)];
      return item ? JSON.parse(item) : item;
    },
    set(key, value) {
      return (VAULT[prepare(key)] = JSON.stringify(value));
    },
    remove(key) {
      return delete VAULT[prepare(key)];
    },
    clear() {
      const keys = Object.keys(VAULT);
      for (const key of keys) {
        delete VAULT[key];
      }
    },
  };
};

const get = key => {
  const logger = Logger('Token Manager');
  const vault = getVault();
  const token = vault.get(key);
  if (token) {
    if (moment().isAfter(moment.unix(token.ttl))) {
      logger.debug('EXPIRED', {
        key,
        now: moment().format(),
        expiresAt: moment.unix(token.ttl).format(),
      });
      vault.remove(key);
      return null;
    }
    return token.value;
  }
  return null;
};

const set = (key, value, ttl) => {
  const vault = getVault();
  const expires = moment.unix(ttl).format();
  return vault.set(key, { ttl, expires, value });
};

const clear = () => {
  getVault().clear();
};

const request = async (auth, scope) => {
  const logger = Logger('Token Manager');

  if (Array.isArray(scope) && scope.length === 0) {
    logger.warn('Cannot request empty');
    return null;
  }

  if (scope === undefined) {
    logger.warn('Cannot request undefined');
    return null;
  }

  if (scope === null) {
    logger.warn('Cannot request null');
    return null;
  }

  logger.debug(`Request ${scope}`);

  const fromMemory = get(scope);
  if (fromMemory) {
    logger.debug(`From memory ${scope}`);
    return fromMemory;
  } else {
    logger.debug(`Not in memory ${scope}`, VAULT);
  }

  try {
    const token = await auth.accessToken(scope);
    logger.debug(`Response ${scope}`, token);
    const { expiresAt } = token;
    set(scope, token.accessToken, expiresAt);
    logger.debug({ scope, expires: moment.unix(expiresAt).format() }, VAULT);
    return token.accessToken;
  } catch (err) {
    logger.debug(`Error on ${scope}`);
    logger.error(err);
    return null;
  }
};

export default { get, clear, request };
